var version = {
    "name":      "dativery",
    "buildDateCode": "20251208-225101",
    "buildDate": "Mon Dec 08 2025 22:51:01 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251208-225101",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;